import { render, staticRenderFns } from "./VideoHeader.vue?vue&type=template&id=14046055&"
import script from "./VideoHeader.vue?vue&type=script&lang=js&"
export * from "./VideoHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports